import {
  keyArgsForPagination,
  mergeForCurriculumWebsiteNodePagination,
} from "./modules/utils";

const CurriculumWebsiteNodePolicy = {
  CurriculumWebsiteNode: {
    fields: {
      children: {
        keyArgs: args => {
          if (args) {
            const keys = keyArgsForPagination(args);
            return keys;
          }
          return [];
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForCurriculumWebsiteNodePagination({
              existing,
              incoming,
              readField,
              filters: args,
            });
          }
          return incoming;
        },
      },
    },
  },
};

export default CurriculumWebsiteNodePolicy;
